module.exports = __webpack_public_path__ + "img/stories-archive-video.jpg?bb37000603618cc18e7c950b85d04cd6";